<template>
  <path
    d="M5 12.0002V4.00024C5 3.45024 4.55 3.00024 4 3.00024C3.45 3.00024 3 3.45024 3 4.00024V12.0002C3 14.7602 5.24 17.0002 8 17.0002H13C13.55 17.0002 14 16.5502 14 16.0002C14 15.4502 13.55 15.0002 13 15.0002H8C6.34 15.0002 5 13.6602 5 12.0002ZM20.5 18.0002H19V11.0002C19 9.90024 18.1 9.00024 17 9.00024H12V3.00024H6V11.0002C6 12.6502 7.35 14.0002 9 14.0002H16V19.0002C16 20.1002 16.9 21.0002 18 21.0002H20.5C21.33 21.0002 22 20.3302 22 19.5002C22 18.6702 21.33 18.0002 20.5 18.0002Z"
  />
</template>
